module.exports = __webpack_public_path__ + "img/ps_img.0a16be23.png";